import $ from 'jquery';
import { debounce } from '../../utils/debounce';

const handleClickTypeEvent = () => {
	const el = {
		container: '.tribe-events-c-view-selector',
		btn: '.tribe-events-c-view-selector__button',
		target: '.tribe-events-c-view-selector__list',
	};

	const init = () => {
		$(function () {
			if (!$(el.container).length) return;

			exec();

			$(window).on('resize', debounce(exec));
		});
	};

	const exec = () => {
		if (window.innerWidth < 800) return;

		$(document).on('click', el.btn, function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $container = $(this).closest(el.container);
			const $target = $container.find(el.target);

			$target.fadeToggle();
		});

		$(document).on('click', function (e) {
			const $target = $(el.target);

			if (
				$target.is(':visible') &&
				!$(e.target).closest(el.target).length &&
				!$(e.target).closest(el.btn).length
			) {
				$target.fadeOut();
			}
		});
	};

	init();
};

try {
	handleClickTypeEvent();
} catch (error) {
	console.error(error);
}
